import React from 'react';
import { useParams } from 'react-router-dom';
import MedicationPrintView from '../../components/medications/MedicationPrintView';

/**
 * /students/:studentId/medications/print — the route wrapper around the
 * print-optimised medication record.
 *
 * Thin on purpose: the studentId is the only thing the URL carries, and every
 * other decision (the date range, what is in range, what prints) belongs to
 * MedicationPrintView, which is also what a future "print from the child's own
 * medication tab" entry point would reuse without a route.
 *
 * Access control is the SERVER's: the record is loaded through
 * `GET /students/{studentId}/medications`, which is gated on
 * `medication:read-staff` at the child's location. This page hides nothing on
 * its own and is not relied on to.
 */
const StudentMedicationPrint: React.FC = () => {
  const { studentId } = useParams<{ studentId: string }>();

  if (!studentId) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-slate-500">
        Invalid URL
      </div>
    );
  }

  return <MedicationPrintView studentId={studentId} />;
};

export default StudentMedicationPrint;
